import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import {format} from 'one-util-date';

import {
    setAction, AgentUserId,setUpdate
} from 'one-state-getuserid';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import { TransformResponse } from './transform';
import { Disposition } from 'one-model-local';
import axios from 'axios';
import { InvokeFinesseProxy } from '../../subject/src/index';

export const enum Types {
    FETCHAGENTID = 'one-state-getuserid/fetch',
    UPDATEAGENTID = 'one-state-updateuserid/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
/**
 * This Fuction will fetch the data of agentid epic
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchEpicUserID = (context: any) => (
    (action$: ActionsObservable<any>, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server,
            log,
            alertnotification,
            agentId, teamName,
            settings:
            {
                epicendpoints: { getepicuserid, apitoken },
                compatible: { contact_center_type, finesse_proxy_service }, servers
            }
        } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(Types.FETCHAGENTID),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the Referrals Response
                 */
                let dataresponse: any = action.payload;
                const getRequest = (datares: any) => {
                    if (datares) {
                        let headers = new Headers();
                        // todo: need to refractor to include authorization in interface
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        let apiparam = "";
                        if (contact_center_type === "finesse") {
                            apiparam = "finessename"
                        }
                        else if (contact_center_type === "five9") {
                            apiparam = "five9name"
                        }
                        else if (contact_center_type === "vonage") {
                            apiparam = "vonage"
                        }
                        else if (contact_center_type === "twilio") {
                            apiparam = "twilio"
                        }
                        else if (contact_center_type === "genesys") {
                            apiparam = "genesys"
                        }
                        else if(contact_center_type === "inContact") {
                            apiparam = "incontact"
                        }
                        else if (contact_center_type === "ringcentral") {
                            apiparam = "ringcentral"
                        } 
                        else if(contact_center_type === "wxcc") {
                            apiparam = "wxcc_user"
                        }  
                        let response;
                        if (finesse_proxy_service) {
                            response = InvokeFinesseProxy(getepicuserid + "?" + apiparam + "=" + datares?.agentuserid,
                                "", apitoken, locations, log, 'GET', alertnotification);

                        } else {
                            response = server.get({
                                path: getepicuserid + "?" + apiparam + "=" + datares?.agentuserid,
                                headers: headers
                            })
                                .then((responsefound: any) => responsefound)
                                .catch((responseresult: any) => {
                                    //Check the Side B server receive communication
                                    if (locations?.length >= 2) {

                                        const receivecommTwo = locations[1]?.base + getepicuserid + "?" + apiparam + "=" + datares?.agentuserid;
                                        const token = 'Basic ' + apitoken?.token;
                                        const response = axios.get(`${receivecommTwo}`, {
                                            headers: {
                                                'Accept': 'application/json',
                                                'Authorization': token,
                                                'Content-Type': 'text/plain'
                                            }
                                        })
                                            .then((response: any) => {
                                                log.debug('Get Epic UserID SUCCESS: ', 'Agenta health check passed with status code:', response)
                                                return response;
                                            })
                                            .catch((response: any) => {
                                                if (datares?.agentId) {
                                                    log.debug('Epic User ID ', 'Response', response);
                                                    let alerterror: ErrorObject = {
                                                        source: "Epic User ID",
                                                        type: "error",
                                                        status: 400,
                                                        erroritems: [],
                                                        error_date: errorDate,
                                                        error_time: errorTime
                                                    };

                                                    // A brief description on how you can troubleshoot our two common errors seen here.
                                                    console.error('Get Epic UserID ERROR: Unable to reach the Agenta server. If cert error (\'ERR_CERT_AUTHORITY_INVALID\'), browse the request URL and accept the certificate. If \'ERR_NAME_NOT_RESOLVED\', verify connection to UPMC server environment.');
                                                    return alerterror;
                                                }
                                            });
                                        return response;
                                    } else {
                                        log.error(
                                            "ccw-gadget,agentid-epic",
                                            "fetch-agentuserid-epic", {
                                            responseresult
                                        }
                                        );
                                    }
                                })
                        }
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response?.agentiddata[0])];
                            if (response.error) {
                                actions.push(addAction(response.error));
                                let disp: Disposition = { value: "2014" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } 
                                else if(contact_center_type==="genesys"){
                                    disp.meta00 = sessionStorage.getItem("name");
                                    disp.meta01 = sessionStorage.getItem("agentName");
                                  }
                                  else if(contact_center_type==="twilio"){
                                    disp.meta00 = sessionStorage.getItem("twilio_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="ringcentral"){
                                    disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="inContact"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                  }
                                  else if(contact_center_type==="vonage"){
                                    disp.meta00 = sessionStorage.getItem("vonage_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="wxcc"){
                                    disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                    disp.meta01 = "";
                                  } 
                                else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse.agentuserid;
                                disp.meta03 = response?.error?.status;
                                disp.meta04 = response?.error?.erroritems[0]?.error_detail;
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "2015" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } 
                                else if(contact_center_type==="genesys"){
                                    disp.meta00 = sessionStorage.getItem("name");
                                    disp.meta01 = sessionStorage.getItem("agentName");
                                  }
                                  else if(contact_center_type==="twilio"){
                                    disp.meta00 = sessionStorage.getItem("twilio_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="ringcentral"){
                                    disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="inContact"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                  }
                                  else if(contact_center_type==="vonage"){
                                    disp.meta00 = sessionStorage.getItem("vonage_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="wxcc"){
                                    disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                    disp.meta01 = "";
                                  } 
                                else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse.agentuserid;
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);


